import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Modal from "../../Modal";
import Panel from "wonderbly-components/lib/Panel";
import Button from "wonderbly-components/lib/Button";
import MultiAdventurer from "../../CreationForm/MultiAdventurer";
import { getTrackingProps } from "../../CreationForm/helpers";
import "./MultiAdventurerModal.scss";

const MultiAdventurerModal = (props) => {
  const byPassModal = props.isModalOpen && props.media.tabletUp;
  const multiAdventurerTrackingProps = getTrackingProps("multi_adventurer");
  return (
    <Fragment>
      {props.arrowImage && (
        <img
          className="multi-adventurer-arrow"
          src={props.arrowImage.url}
          alt={props.arrowImage.alt || ""}
        />
      )}
      <Button {...props.buttonTheme} onClick={props.onModalToggle} fullWidth>
        {props.cta}
      </Button>
      <Modal
        className="multi-adventurer-modal"
        bypass={byPassModal}
        isOpen={props.isModalOpen}
      >
        <Panel className="multi-adventurer-panel">
          {!byPassModal && (
            <div className="multi-adventurer-panel__header">
              <Button
                className="multi-adventurer-panel__close"
                onClick={props.onModalToggle}
                unstyled
              >
                {props.cancel}
              </Button>
            </div>
          )}
          <div className="multi-adventurer-panel__content">
            <MultiAdventurer
              productId={props.productId}
              form={props.form}
              fetchPrismicProduct={props.fetchPrismicProduct}
              handleAdventurerSubmission={props.submitMultiAdventurerForm}
              {...multiAdventurerTrackingProps}
            />
          </div>
        </Panel>
      </Modal>
    </Fragment>
  );
};

MultiAdventurerModal.propTypes = {
  currentScrollPos: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  cancel: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  buttonTheme: PropTypes.object.isRequired,
  arrowImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }).isRequired,
  media: PropTypes.shape({
    tabletUp: PropTypes.bool.isRequired,
  }).isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  onModalToggle: PropTypes.func.isRequired,
  fetchPrismicProduct: PropTypes.func.isRequired,
  submitMultiAdventurerForm: PropTypes.func.isRequired,
};

export default MultiAdventurerModal;
